module.exports = __webpack_public_path__ + "static/media/2-Attal.d6546df8.webp";